module.exports = __webpack_public_path__ + "static/img/ksrk_logo7.25cd160.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo7.png
// module id = urll
// module chunks = 1